import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgApplicationTabService} from 'exc-tab-v2';
import {ExcRestService, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {ExcSecurityService} from 'exc-security-v2';
import {ExgDataTableComponent, ExgModalService} from 'exc-controls-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ApplicationService} from '../../services/application.service';
import {DataService} from '../../services/data.service';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';

@Component({
  selector: 'app-layout-views',
  templateUrl: './layout-views.component.html',
  styles: [
  ]
})
export class LayoutViewsComponent extends ExcTranslation implements OnInit {
  @Input()
  mainTable?: any;

  @ViewChild('VCViewTable', {read: ExgDataTableComponent}) VCViewTable!: ExgDataTableComponent;

  viewTable = {
    selectKey: 'compID',
    state: 1,
    selectedRow: undefined as any,
    prefilter_DEL: 0,
    searchValue: '',
    uiFilter: [],
    uiSort: [],
    data: [] as any [],
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter
    } as IExcMetaInfo,
    paging: {pagingPage: 0, pagingEndRow: 0, pagingPageSize: 25, pagingTotalPages: 0, pagingTotalRows: 0, pagingStartRow: 0},
    isLoading: false,
    selectionChanged: (index: number) => {
      this.viewTable.selectedRow = this.viewTable.data[index];
    },
    pageChanged: (page: number) => {
      if (this.viewTable.MetaInfo.dataPaging !== undefined) {
        this.viewTable.MetaInfo.dataPaging.pageNo = page;
      }
    },
    search: (value: string) => {
      this.viewTable.searchValue = value;
      this.viewTable.pageChanged(0);
    },
    ready: () => {
      this.viewTable.isLoading = false;
      if (this.viewTable.data.length === 0) {
        this.viewTable.state = 2;
        this.VCViewTable.selectedRow = -1;
      } else {
        this.viewTable.state = 0;
        this.VCViewTable.selectedRow = 0;
      }
    },
    loadData: (incomingData: any, incomingPaging: any) => {
      this.viewTable.data = incomingData.filter((comp: any) => comp.compDEL === false);
      this.viewTable.paging = incomingPaging;
      this.viewTable.ready();
    },
    isFiltered: () => {
      return !(this.viewTable.MetaInfo.dataFilter);
    }
  };

  config = {
    table: {
      searchValue: '',
      selectKey: 'field',
      selectedRow: undefined as any,
      selectionChanged: (index: number) => {
        this.config.table.selectedRow = this.mainTable[index];
      },
      search(value: string): void {
        this.searchValue = value;
      },
    }
  };

  constructor(
    private exgApplicationTabService: ExgApplicationTabService,
    public excRest: ExcRestService,
    public excSecurity: ExcSecurityService,
    private modalSvc: ExgModalService,
    public enumSvc: EnumerationService,
    public appSvc: ApplicationService,
    private dataSvc: DataService
  ) {
    super();
  }

  ngOnInit(): void {
    this.init();
  }

  init(): void {
    this.viewTable.data = this.mainTable;
  }
}

